import MasterChef from "../assets/projects/MasterChef.png";
import NotYoutube from "../assets/projects/NotYoutube.png";
import NetflixGPT from "../assets/projects/NetflixGPT.png";
import WCV from "../assets/projects/WCV.jpeg";
import HangMan from "../assets/projects/HangMan.png";

export const projects = [
  {
    id: 1,
    name: "Not-YouTube",
    image: NotYoutube,
    github: "https://github.com/Ayush5601/React-YouTube",
    live: "https://main--you-tube-react.netlify.app/",
  },
  {
    id: 2,
    name: "NetFlix GPT",
    image: NetflixGPT,
    github: "https://github.com/Ayush5601/MoviesGPT",
    live: "https://entertainmentgpt.netlify.app/",
  },
  {
    id: 3,
    name: "HangMan",
    image: HangMan,
    github: "https://github.com/Ayush5601/HangMan",
    live: "https://ayush5601.github.io/HangMan/",
  },
  {
    id: 4,
    name: "MasterChef",
    image: MasterChef,
    github: "https://github.com/Ayush5601/React-Swiggy",
    live: "https://fooddddy.netlify.app/",
  },
  {
    id: 5,
    name: "Word Count Visualizer",
    image: WCV,
    github: "https://github.com/Ayush5601/WordCountVisualiser",
    live: "https://ayush5601.github.io/WordCountVisualiser/",
  },
];
